import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

export function getQuestions(businessCode) {
  return apiClient
    .get(`${ApiConfig.SurveyConfig.SurveyQuestions}${businessCode}`)
    .then(response => response?.data?.questions ?? [])
}

export function getQuestionTypes(businessCode) {
  return Promise.all([
    apiClient
      .get(`${ApiConfig.SurveyConfig.QuestionTypes}${businessCode}`)
      .then(response => response?.data?.answer_types ?? []),
    apiClient
      .get(`${ApiConfig.SurveyConfig.Reviews}${businessCode}`)
      .then(response => response?.data?.reviews ?? []),
  ])
}

function createSurvey(businessCode) {
  return apiClient
    .get(`${ApiConfig.SurveyConfig.CreateSurveyQuestion}${businessCode}`)
    .then(response => response?.data)
}

export default createSurvey
